
import { defineComponent, PropType } from 'vue';
import { useProcessAvatar } from '@/composables';
import { hashColorClassNames } from '@/utils/colors';
import { CardRatingItem } from './types';

export default defineComponent({
  props: {
    /** 点评数据项 */
    rating: { type: Object as PropType<CardRatingItem>, required: true },
  },
  emits: ['click-avatar'],
  setup() {
    const { processAvatar } = useProcessAvatar();
    return {
      processAvatar,
    };
  },
  computed: {
    timeDiff() {
      const res: string = this.rating.createdAt.fromNow();
      return res;
    },
    starColor(): string {
      return this.rating.starred ? '#ef755a' : '';
    },
    courseCardColor(): string {
      // TODO: 有实际分类意义的配色
      return hashColorClassNames(parseInt(this.rating.lecture.id, 10) || 0);
    },
  },
  methods: {
    handleClickAvatar() {
      this.$emit('click-avatar', this.rating.creator.id);
    },
  },
});
